import { render } from "./Logs.vue?vue&type=template&id=a9c30800&ts=true"
import script from "./Logs.vue?vue&type=script&lang=ts"
export * from "./Logs.vue?vue&type=script&lang=ts"

import exportComponent from "/var/www/kemet/front/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__